import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { Action } from '@hh.ru/magritte-ui-action';
import { s as styles, C as ChipContent } from './ChipContent-CS4N9BNF.js';
import { CrossOutlinedSize16, CrossOutlinedSize24 } from '@hh.ru/magritte-ui-icon/variants/icon';
import '@hh.ru/magritte-ui-typography';

const STYLE_TO_CSS = {
    neutral: styles.chipStyleNeutral,
    accent: styles.chipStyleAccent,
};
const CustomChipComponent = ({ Element = 'button', addon, style = 'neutral', postfix, onDelete, deleteOnly = false, checked = false, disabled = false, 'aria-label': ariaLabel, hideLabel, dataQaWrapper = 'chip', children, size = 'medium', mode = 'primary', ...buttonProps }, ref) => {
    const forceDisabled = useDisabled();
    const isComponentDisabled = disabled || forceDisabled;
    let additionalAttributes;
    if (Element === 'button') {
        additionalAttributes = {
            type: 'button',
            tabIndex: isComponentDisabled || deleteOnly ? -1 : 0,
        };
    }
    else {
        additionalAttributes = {
            tabIndex: isComponentDisabled || deleteOnly ? -1 : 0,
            'aria-disabled': disabled,
        };
    }
    if (ref) {
        additionalAttributes.ref = ref;
    }
    return (jsxs("div", { className: classnames(styles.chipWrapper, isComponentDisabled && styles.chipWrapperDisabled), "data-qa": dataQaWrapper, children: [jsx(Element, { ...additionalAttributes, ...buttonProps, className: classnames(styles.chip, styles.chipCustom, STYLE_TO_CSS[style], {
                    [styles.chipChecked]: checked,
                    [styles.deleteOnly]: deleteOnly,
                    [styles.sizeSmall]: size === 'small',
                    [styles.disabled]: isComponentDisabled,
                    [styles.chipSecondary]: mode === 'secondary',
                }), disabled: isComponentDisabled || deleteOnly, children: jsx(ChipContent, { postfix: postfix, onDelete: onDelete, addon: addon, "aria-label": ariaLabel, hideLabel: hideLabel, size: size, mode: mode, children: children }) }), onDelete && (jsx("span", { className: classnames(styles.close, { [styles.closeSecondary]: mode === 'secondary' }), children: jsx(Action, { "data-qa": "chip-delete-action", onClick: onDelete, disabled: isComponentDisabled, mode: "secondary", icon: size === 'small' || mode === 'secondary' ? CrossOutlinedSize16 : CrossOutlinedSize24 }) }))] }));
};
const CustomChip = forwardRef(CustomChipComponent);

export { CustomChip };
//# sourceMappingURL=CustomChip.js.map
